import { useRef, useState } from 'react';
import { FileImage, ScanBarcode, X } from 'lucide-react';
import { decodeShareCode } from '../core/shareCode';

export function SharePatternScannerModal({ onFound, onClose }: { onFound: (patternId: string) => void; onClose: () => void }) {
  const input = useRef<HTMLInputElement>(null);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');
  async function scan(file: File | null) {
    if (!file) return;
    setWorking(true); setError('');
    try {
      const bitmap = await createImageBitmap(file);
      const canvas = document.createElement('canvas');
      canvas.width = bitmap.width; canvas.height = bitmap.height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) throw new Error('无法读取图片');
      context.drawImage(bitmap, 0, 0);
      bitmap.close();
      const patternId = decodeShareCode(context.getImageData(0, 0, canvas.width, canvas.height));
      if (!patternId) throw new Error('没有识别到伊小满分享条形码，请上传原始分享图纸');
      onFound(patternId);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : '识别失败');
    } finally { setWorking(false); if (input.current) input.current.value = ''; }
  }
  return <div className="modal-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="share-scanner-modal" role="dialog" aria-modal="true" aria-labelledby="share-scan-title">
      <button className="modal-close icon-button" type="button" onClick={onClose} aria-label="关闭"><X size={18} /></button>
      <span className="share-scan-icon"><ScanBarcode size={30} /></span>
      <h2 id="share-scan-title">扫描分享图纸</h2>
      <p>上传由本站“分享图纸”导出的原始 PNG，我们会读取右上角的一维识别码并打开对应图纸卡片。</p>
      <input ref={input} hidden type="file" accept="image/png,image/jpeg,image/webp" onChange={(event) => void scan(event.target.files?.[0] || null)} />
      <button className="primary-button" type="button" disabled={working} onClick={() => input.current?.click()}><FileImage size={18} />{working ? '正在识别…' : '选择分享图纸'}</button>
      {error && <div className="form-error" role="alert">{error}</div>}
      <small>仅识别本站专用条形码，不使用二维码。</small>
    </section>
  </div>;
}

